import { Component, AfterViewInit } from '@angular/core';
import { MdDialog } from '@angular/material';
import { TdDialogService } from '@covalent/core';

@Component({
  selector: 'qs-preguntasobligatorias',
  templateUrl: './preguntasobligatorias.component.html',
})

export class PreguntasObligatoriasComponent implements AfterViewInit {

  constructor(private _dialogService: MdDialog) { }

  // tslint:disable-next-line: no-empty
  ngAfterViewInit(): void {
  }

  close(): void {
    this._dialogService.getDialogById('11').close();

  }
}



// WEBPACK FOOTER //
// ./src/app/consulta/modanamnesis/preguntasobligatorias/preguntasobligatorias.component.ts